const constants = {
    ACTIONS : {
    GET_COVIDPACK_LOADING : 'GET_COVIDPACK_LOADING',
    GET_COVIDPACK : 'GET_COVIDPACK',
    GET_COVIDPACK_FAIL:'GET_COVIDPACK_FAIL'
    }
}
export default constants;